export function resolveFreshQueryResults<T>(
  data: { results?: T[] } | undefined,
  isPreviousData?: boolean,
): T[] | undefined {
  if (isPreviousData) {
    return undefined;
  }
  return data?.results;
}
